import "./i18n/i18n";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AboutAida } from "./pages/AboutAida/AboutAida";
import { Admin } from "./pages/Admin/Admin";
import { Books } from "./pages/Books/Books";
import { Contact } from "./pages/Contact/Contact";
import { Footer } from "./layouts/Footer";
import { Frontpage } from "./pages/Frontpage/Frontpage";
import { Impressum } from "./pages/Impressum/Impressum";
import { Lectures } from "./pages/Lectures/Lectures";
import { Media } from "./pages/Media/Media";
import { Navbar } from "./layouts/Navbar";
import { OnlineCourses } from "./pages/OnlineCourses/OnlineCourses";
import { Podcast } from "./pages/Podcast/Podcast";
import { ScrollToTop } from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Frontpage />} />
        <Route path="/about" element={<AboutAida />} />
        <Route path="/books" element={<Books />} />
        <Route path="/podcast" element={<Podcast />} />
        <Route path="/lectures" element={<Lectures />} />
        <Route path="/media" element={<Media />} />
        <Route path="/courses" element={<OnlineCourses />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
